<template>
  <span v-if="value">{{ value }}</span>
  <span v-else>n/a</span>
</template>

<script>
export default {
  name: 'value-with-default-na',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
}
</script>
